/** Build-time settings (Vite `import.meta.env`, defaults from @saay/web-config/vite). */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  /** Dev only: `fake` swaps Keycloak for the test double (see src/dev/). */
  authMode: import.meta.env.VITE_AUTH_MODE === 'fake' ? 'fake' : 'oidc',
  oidcAuthority: import.meta.env.VITE_OIDC_AUTHORITY,
  useMocks: import.meta.env.VITE_USE_MOCKS === 'true',
} as const;
